export default "__VITE_ASSET__CeSmlvaJ__"